import NextImage, { NextImageProps } from '@/components/atoms/Image';
import LinkButton, {
  LinkButtonProps,
} from '@/components/atoms/LinkButton';

export type MenuCarouselItemProps = {
  isActive: boolean;
  image: NextImageProps;
  link: LinkButtonProps;
  ref?: React.RefCallback<HTMLAnchorElement | null>;
};

export function MenuCarouselItem({
  image,
  isActive,
  link,
  ref,
}: MenuCarouselItemProps) {
  return (
    <LinkButton
      noStyles
      href={link.href}
      className='focus-visible:ring-brand-500 relative inline-block size-full after:absolute after:inset-0.5 after:bg-blend-exclusion focus:outline-none focus-visible:after:ring-4'
      aria-hidden={!isActive}
      tabIndex={isActive ? 0 : -1}
      ref={ref}
    >
      <NextImage
        {...image}
        objectFit='cover'
        classNames={{
          container: 'h-full',
          image: 'h-full',
        }}
      />
      <div className='sr-only'>Go to {link.children}</div>
    </LinkButton>
  );
}
